module.exports = __webpack_public_path__ + "prod/20260929161836/img/logo.1444e71b.png";